import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { config } from "../../utils/config";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Varient from "../../assets/img/varient.png";
import { useForm } from "react-hook-form";
import KEYS from "../../env/env";
// import secureLocalStorage from "react-secure-storage";
import { doRequest, submitUserPlans } from "../../utils/helper";
import verifytoken from "../../env/verifytoken";
import Loader from "../../components/Loader";
import { useDispatch } from "react-redux";
import {
  setAllData,
  setPlanDetails,
  setVariationCountDetails,
} from "../../redux/slices/PlanDetailSlice";
import { loginwithgoogle } from "./LoginWithGoogle";
import "../../design/css/login.css"
import doneIcon from "../../assets/loginimg/doneicn.svg"
import eyeIcon from "../../assets/loginimg/eyeicn.svg"
import googleIcon from "../../assets/loginimg/googleglogo.svg"
import teedexlogo from "../../assets/loginimg/teedexlogo.svg"
import { toast } from "react-toastify";




function Login() {
  const dispatch = useDispatch();
  // const loginToken = secureLocalStorage.getItem("Login");
  const loginToken = localStorage.getItem("Login");
  const initialUserPlanDetails = localStorage.getItem(config.USER_PLAN_DETAILS);
  const [isEmailChecked, setIsEmailChecked] = useState(false);
  const [checkEmailLoading, setCheckEmailLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errmsg, setErrorMsg] = useState(null);
  const [loading, setLoading] = useState(false);
  const [emailValid, setEmailValid] = useState(false);
  const [emailValue, setEmailValue] = useState("");
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const plan = params.get("plan");
  if (plan) {
    localStorage.setItem("userselectedplanid", plan);
  } else {
    if (localStorage.getItem("userselectedplanid")) {
      localStorage.removeItem("userselectedplanid");
    }
  }

  useEffect(() => {
    const token = localStorage.getItem("Login");
  
    // 1. If token exists AND is VALID → force redirect to dashboard
    if (token && !verifytoken()) {   // !verifytoken() = valid token
      navigate("/", { replace: true });
      return; // stop further execution
    }
  
    // 2. If token exists BUT is INVALID/EXPIRED → clean up
    if (token && verifytoken()) {
      localStorage.removeItem("Login");
      localStorage.clear();
      // No need to navigate — user can stay on login
    }
  
    // 3. No token → do nothing, stay on login page
  }, [navigate]);

  const togglePasswordVisibility = () => {
    setShowPassword(prev => !prev);
  };

  const handleEmailChange = (e) => {
    const email = e.target.value;
    setEmailValue(email);
    setValue("emailid", email);

    // Email regex pattern
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

    // Check if email is valid
    if (email && emailRegex.test(email)) {
      setEmailValid(true);
    } else {
      setEmailValid(false);
    }
  };

  const {
    register,
    formState: { errors },
    setError,
    handleSubmit,
    clearErrors,
    setValue
  } = useForm();

  const submitUserPlan = async (planid) => {
    let user =
      localStorage.getItem(config.USER_LOGIN_DETAILS) &&
      JSON.parse(localStorage.getItem(config.USER_LOGIN_DETAILS));
    try {
      let response = await submitUserPlans(planid, user);
      if (response && +response?.resultFlag === 1) {
        localStorage.removeItem("users_email");
        let details = response?.response?.user_data;
        let userPlan = response?.response?.userPlan;
        let variant = response?.response?.variants;
        if (variant) {
          localStorage.setItem(config.VARIANT_COUNT, JSON.stringify(variant));
        }
        localStorage.setItem(
          config.USER_LOGIN_DETAILS,
          JSON.stringify(details)
        );
        localStorage.setItem(
          config.USER_PLAN_DETAILS,
          JSON.stringify(userPlan)
        );

        // dispatch(setPlanDetails({ userPlanDetails: userPlan }));
        // dispatch(setVariationCountDetails(variant))
        dispatch(setAllData({ userPlanDetails: userPlan, variants: variant }));
        if (initialUserPlanDetails) {
          navigate("/profile?plan=" + planid);
        } else {
          navigate("/profile?plan=" + planid + "&ftime=1");
        }
      } else {
        setErrorMsg(
          response?.message ? response?.message : "Something went wrong"
        );
      }
    } catch (error) {
      setErrorMsg(error?.message ? error?.message : "Something went wrong");
    }
  };

  const resendOtp = async (email) => {
    try {
      let data = {
        email,
      };
      let response = await doRequest(data, "POST", "user/resend-otp");
      if (+response?.resultFlag === 1) {
        localStorage.setItem("users_email", email);
        navigate("/verify-email" + window.location.search);
      } else {
        setErrorMsg(
          response?.message ? response?.message : "Something went wrong!"
        );
      }
    } catch (error) {
      setErrorMsg(error?.message ? error?.message : "Something went wrong!");
    }
  };

  var login = (data) => {
    setLoading(true);
    try {
      let obj = {
        email: data.emailid,
      };
      window.gtag("event", "Login User", obj);
    } catch (error) { }
    var dataToPost = {
      email: data.emailid,
      password: data.password,
    };

    fetch(KEYS.apiPath + "user/login", {
      body: JSON.stringify(dataToPost),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (val) => {
        if (+val.resultFlag === 1) {
          let user = val?.response?.user;
          // secureLocalStorage.setItem("Login", val?.response?.token);
          localStorage.setItem("Login", val?.response?.token);
          let userDetails = val?.response?.user;
          let userPlanDetails = val?.response?.userPlan;
          let variants = val?.response?.variants;

          localStorage.setItem(
            config.USER_LOGIN_DETAILS,
            JSON.stringify(userDetails)
          );
          localStorage.setItem(
            config.USER_PLAN_DETAILS,
            JSON.stringify(userPlanDetails)
          );
          if (variants) {
            localStorage.setItem(
              config.VARIANT_COUNT,
              JSON.stringify(variants)
            );
            dispatch(setPlanDetails({ userPlanDetails: userPlanDetails }));
          }
          if (user?.status === "inactive") {
            await resendOtp(user?.email);
          } else {
            if (user?.user_plan_id) {
              if (userPlanDetails?.plan_id == "1") {
                localStorage.setItem("showfreevariantpopup", "true");
              }
              // navigate("/Home");
              window.location.href = "/";
              setErrorMsg(null);
            } else {
              if (plan) {
                if (plan == "1" || plan == "2") {
                  await submitUserPlan(plan);
                } else {
                  navigate("/payment" + window.location.search);
                }
              } else {
                navigate("/plans" + window.location.search);
              }
            }
          }
        } else {
          setErrorMsg(val["message"] ? val["message"] : "Something went wrong");
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setErrorMsg(err?.message ? err.message : "Something went wrong!");
      });
  };

  const checkEmail = async (email) => {
    try {

      clearErrors("emailid");

      if (!email) {
        setError("emailid", { type: "required", message: "Email is required." });
        return false;
      }

      setCheckEmailLoading(true);

      const response = await doRequest({ email }, "POST", "user/check-email");
      // console.log("Response is: ", response?.response?.is_exists);

      if (response?.response?.is_exists) {
        setIsEmailChecked(true);
      }
      else {
        navigate(`/signup?email=${email}`)
      }


      setCheckEmailLoading(false);
    }
    catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }
    finally {
      setCheckEmailLoading(false);
    }

  }

  return (
    <>
      {loading && <Loader />}

      <div className="newLoginBody">
        <div className="newLoginBodyText">
          <div className="newLoginFormContainer newLoginFormBlock">
            <h1>
              {isEmailChecked ? "Login" : "Login/Sign Up"}
            </h1>
            <p>Welcome back! Please enter your details</p>
            <div className="googlelogin">
              <a href="#" className="googleLoginButton" onClick={(e) => {
                e.preventDefault();
                loginwithgoogle(); // trigger redirect
              }}>
                <img src={googleIcon} alt="Google Logo" />
                <span>Continue with Google</span>
              </a>
            </div>
            <div className="orLogin"><span>or</span></div>
            <form onSubmit={handleSubmit(isEmailChecked ? login : (data) => checkEmail(data.emailid))}>

              <div className="inputContainer">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  {...register("emailid", {
                    required: true,
                    pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  })}
                  onChange={handleEmailChange}
                  disabled={isEmailChecked}
                />

                {emailValid && <div className="verified"><img src={doneIcon} alt="done icon" /></div>}


              </div>
              {errors.emailid?.type === "required" && (
                <div className="text-danger" style={{ marginBottom: ".365vw" }}>Email is required.</div>
              )}
              {errors.emailid?.type === "pattern" && (
                <div className="text-danger" style={{ marginBottom: ".365vw" }}>
                  Please enter valid email.
                </div>
              )}


              {isEmailChecked ?
                <>
                  <div className="inputContainer">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Password"
                      style={{ paddingRight: "30px" }}
                      {...register("password", { required: true })}
                    />

                    <div
                      className={`showPassword ${showPassword ? "showed" : ""}`}
                      onClick={togglePasswordVisibility}>
                      <img src={eyeIcon} alt="eye icon" />
                    </div>
                  </div>
                  {errors.password?.type === "required" && (
                    <span className="text-danger">
                      Password is required.
                    </span>
                  )}
                  <p style={{ margin: 0 }} className="text-danger">
                    {errmsg != null ? errmsg : ""}
                  </p>
                  <div className="inputContainer">
                    <button type="submit" className="loginButton">Login</button>
                  </div>

                </> :
                <div className="inputContainer">
                  {/* <button type="button" className="loginButton" onClick={() => checkEmail(emailValue)}>Next</button> */}
                  <button type="submit" className="loginButton">Next</button>

                </div>}


            </form>
            <div className="loginRemember">
              <label for="rememberMe">
                <input type="checkbox" value="" id="rememberMe" name="rememberMe" />
                Remember for 30 days
              </label>
            </div>
            <div className="forgotPassword">
              <Link to="/Forgetpass" >
                Forget Password?
              </Link>
              {/* <a href="#">Forgot Password?</a> */}
            </div>
          </div>
          <div className="formTnc newLoginFormBlock">
            By signing up for teedex you acknowledge that you agree to teedex <a href="#">Terms & Conditions</a> and <a href="#">Privacy Policy</a>
          </div>
          <div className="formTeedexLogo newLoginFormBlock">
            <img src={teedexlogo} alt="Teedex Logo" />
          </div>
          <div className="formCopyR newLoginFormBlock">© 2025 Teedex All Rights Reserved</div>
        </div>

        <div className="newLoginBodyImg"></div>
      </div>

    </>
  );
}

export default Login;
